import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export function getCurrentShipToState(state: ApplicationState) {
    const currentShipToId = state.context.session?.shipToId;
    const currentShipTo = state.data.shipTos?.byId[currentShipToId ?? ""];
    return currentShipTo;
}
